// extracted by mini-css-extract-plugin
export default {"Console":"styles_Console__jRwQG","title":"styles_title__eOGjg","managementMenuContainer":"styles_managementMenuContainer__m2PWI"};